import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/Layout/Header/Header";
import Footer from "../../components/Layout/Footer/Footer";
import ScrollToTop from "../../components/Common/ScrollTop";
import OffWrap from "../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../components/Common/Breadcumb";
import SearchModal from "../../components/Layout/Header/SearchModal";
import footerLogo from "../../assets/img/logo/jntua-logo.png";
import { Link } from "react-router-dom";
import Accreditation from "../../components/Common/Accreditation";
import { AdministrationMenu } from "../../components/Common/SidebarMenu";
import SideBar from "../../components/Common/SideBar";
import RightSidebar from "../../components/Common/RightSidebar";
import Pagination from "../../components/Pagination";
import { useFontSize } from "../../FontSizeContext";
import axios from "../../utils/axios.config";

const Directorates = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(25);
  const totalItems = data?.meta?.pagination?.total;
  const { fontSize } = useFontSize();
  const fetchDataSequentially = async () => {
    for (let i = 0; i < directorates.length; i++) {
      try {
        const obj = directorates[i];
        const result = await axios.get(
          `${obj?.url}?populate[0]=Gallery&populate[1]=jntuk_directorate&populate[2]=jntuk_directorate.Image`
        );
        const updatedResult = { ...result.data, link: obj?.link };
        setData((prevData) => {
          const newData = [...prevData];
          newData[i] = updatedResult;
          return newData;
        });
      } catch (error) {
        console.error(
          `Error fetching data for ${directorates[i]?.url}: ${error.message}`
        );
      }
    }
  };

  useEffect(() => {
    setData([]);
    fetchDataSequentially();
  }, [directorates, currentPage]);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  return (
    <React.Fragment>
      <Helmet>
        <title>Directorates | JNTU Anantapur</title>
        <meta
          name="description"
          content="Directorates of Jawaharlal Nehru Technological University Anantapur"
        />
        <meta
          name="keywords"
          content="Directorates of Jawaharlal Nehru Technological University Anantapur"
        ></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <style>
        {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .college-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }
                    
                `}
      </style>
      <div className="pageTopOffset">
        {/* breadcrumb-area-start */}
        <SiteBreadcrumb
          pageTitle="Directorates"
          pageName="Directorates"
          breadcrumbsClass="breadcrumb-bg"
        />
        {/* breadcrumb-area-start */}

        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 xl-mb-30">
                <div className="about-intro">
                  <AdministrationMenu />
                  <SideBar />
                </div>
              </div>
              <div className="col-xl-6 pl-20 xl-pl-14">
                <div className="row">
                  <div className="rs-inner-blog col-lg-12">
                    <h3 className="college-title" title="Directorates">
                      Directorates
                    </h3>
                    <div className="overflow-x">
                      <table className="table table-striped table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">S.No</th>
                            <th scope="col">Name</th>
                            <th scope="col">Designation</th>
                            <th scope="col">Profile</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.map(({ data, link }, index) => (
                            <tr>
                              <td>
                                {((currentPage - 1) * itemsPerPage + index + 1)
                                  .toString()
                                  .padStart(2, "0")}
                                .
                              </td>
                              <td>
                                {
                                  data?.attributes?.jntuk_directorate?.data
                                    ?.attributes?.Name
                                }
                              </td>
                              {/* <td>
                                <BlocksRenderer
                                  content={
                                    data?.attributes?.jntuk_directorate?.data
                                      ?.attributes?.Designation || []
                                  }
                                />
                              </td> */}
                              <td>
                                {
                                  data?.attributes?.jntuk_directorate?.data
                                    ?.attributes?.Designation
                                }
                              </td>
                              <td>
                                <Link to={`/profile${link}`}>
                                  Click&nbsp;Here
                                </Link>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <Pagination
                        currentPage={currentPage}
                        paginate={paginate}
                        arrayLength={totalItems / itemsPerPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 pl-40 xl-pl-14">
                <RightSidebar />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Accreditation />

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup orange-color" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};
const directorates = [
  { url: "/jntua-dap-director", link: "/academics-and-planning-dap" },
  { url: "/jntua-dap-director-audit", link: "/director-academic-audit" },
  { url: "/jntua-dap-director-admission", link: "/admissions-da" },
  { url: "/jntua-dap-director-evaluation", link: "/director-of-evaluation-de" },
  { url: "/jntua-drd-department", link: "/director-research-and-development" },
  {
    url: "/ics-department",
    link: "/director-of-industrial-consultancy-services",
  },
  {
    url: "/faam-department",
    link: "/director-of-foreign-affairs-alumni-matters",
  },
  { url: "/jntua-fdc-director", link: "/director-of-faculty-development-iqac" },
  { url: "/sdc-department", link: "/software-development-centre" },
  { url: "/wec-department", link: "/women-empowerment-cell" },
  { url: "/iqac-department", link: "/internal-quality-assurance-cell" },
  {
    url: "/otpri-department",
    link: "/director-of-oil-technological-pharmaceutical-research-institute",
  },
  { url: "/jntua-sms-director", link: "/school-of-management-studies" },
];
export default Directorates;
